import axios from 'axios';
// Récupère l'URL de base de l'API depuis les variables d'environnement
export const API_BASE_URL = 'https://api.parex.tn/api';
export const API_UPLOAD_URL='https://api.parex.tn';
// Crée une instance d'axios avec une configuration par défaut
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour mieux gérer les erreurs (optionnel mais recommandé)
api.interceptors.response.use(
  (response) => response, // Si la réponse est réussie (status 2xx), on la retourne
  (error) => {
    // Si une erreur se produit, on peut la logger ici ou la transformer
    // Axios rejette la promesse pour les status non-2xx, ce qui simplifie les try/catch
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;

/**
 * Format image URL properly, handling absolute URLs and avoiding double slashes.
 */
export const getImageUrl = (url: string | null | undefined): string => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  const baseUrl = API_UPLOAD_URL.endsWith('/') ? API_UPLOAD_URL.slice(0, -1) : API_UPLOAD_URL;
  const cleanPath = url.replace(/^\/+/, '/');
  return `${baseUrl}${cleanPath.startsWith('/') ? '' : '/'}${cleanPath}`;
};

/**
 * Fetch products for a parent category slug (includes descendants).
 * Matches server behaviour: findAllByParentCategory(parentCategorySlug: string, take?: number)
 * Example backend route expected: GET /products/by-parent-category/:slug?take=12
 */
export async function findAllByParentCategory(parentCategorySlug: string, take?: number) {
  if (!parentCategorySlug) return [];
  const encoded = encodeURIComponent(parentCategorySlug);
  const url = `/products/by-parent-category/${encoded}`;
  const res = await api.get(url, { params: take ? { take } : undefined });
  return res.data;
}